export default [
  {
    number: 31,
    class: 'muted',
    title: ''
  },
  {
    number: 1,
    class: '',
    title: ''
  },
  {
    number: 2,
    class: '',
    title: ''
  },
  {
    number: 3,
    class: 'event',
    title: `Inscrição HackFools`
  },
  {
    number: 4,
    class: 'class',
    title: `dev.learn("básico") - CSS part.2 - Sala 3009 das 14:00 as 15:40 - 
    Inscrição HackFools`
  },
  {
    number: 5,
    class: 'event',
    title: 'Inscrição HackFools'
  },
  {
    number: 6,
    class: 'class',
    title: `dev.learn("básico") - CSS part.2 - Sala 3009 das 13:00 as 14:40 - 
    dev.learn("avançado") - Integração Back/FrontEnd - Sala 3009 das 15:00 as 16:40 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 7,
    class: '',
    title: ''
  },
  {
    number: 8,
    class: '',
    title: ''
  },
  {
    number: 9,
    class: '',
    title: ''
  },
  {
    number: 10,
    class: '',
    title: ''
  },
  {
    number: 11,
    class: '',
    title: ''
  },
  {
    number: 12,
    class: '',
    title: ''
  },
  {
    number: 13,
    class: 'hackathon',
    title: 'HackFools'
  },
  {
    number: 14,
    class: '',
    title: ''
  },
  {
    number: 15,
    class: 'off',
    title: 'Semana Santa - Não haverá aula'
  },
  {
    number: 16,
    class: 'off',
    title: 'Semana Santa - Não haverá aula'
  },
  {
    number: 17,
    class: 'off',
    title: 'Semana Santa - Não haverá aula'
  },
  {
    number: 18,
    class: 'off',
    title: 'Semana Santa - Não haverá aula'
  },
  {
    number: 19,
    class: 'off',
    title: 'Semana Santa - Não haverá aula'
  },
  {
    number: 20,
    class: 'off',
    title: 'Semana Santa - Não haverá aula'
  },
  {
    number: 21,
    class: '',
    title: ''
  },
  {
    number: 22,
    class: '',
    title: ''
  },
  {
    number: 23,
    class: '',
    title: ''
  },
  {
    number: 24,
    class: '',
    title: ''
  },
  {
    number: 25,
    class: 'class',
    title: 'dev.learn("básico") - JS part.1 - 14:00 as 15:40'
  },
  {
    number: 26,
    class: '',
    title: ''
  },
  {
    number: 27,
    class: 'class',
    title: `dev.learn("básico") - JS part.1 - 13:00 as 14:40 - 
    dev.learn("avançado") - A Definir - 15:00 as 16:40 - 
    OBS: O conteudo dessas aulas é o mesmo que a de quarta e quinta`
  },
  {
    number: 28,
    class: '',
    title: ''
  },
  {
    number: 29,
    class: '',
    title: ''
  },
  {
    number: 30,
    class: '',
    title: ''
  },
  {
    number: 1,
    class: 'muted',
    title: ''
  },
  {
    number: 2,
    class: 'muted',
    title: ''
  },
  {
    number: 3,
    class: 'muted',
    title: ''
  },
  {
    number: 4,
    class: 'muted',
    title: ''
  },
  {
    number: 5,
    class: 'muted',
    title: ''
  },
  {
    number: 6,
    class: 'muted',
    title: ''
  },
  {
    number: 7,
    class: 'muted',
    title: ''
  },
  {
    number: 8,
    class: 'muted',
    title: ''
  },
  {
    number: 9,
    class: 'muted',
    title: ''
  },
  {
    number: 10,
    class: 'muted',
    title: ''
  },
  {
    number: 11,
    class: 'muted',
    title: ''
  }
]